// John Eldhose 20181109
import { RestfulPost } from './Restful';

export async function getRegistration(data) {
  const reg = await RestfulPost('getRegistration', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return reg;
}



// WEBPACK FOOTER //
// ./src/Api/getRegistration.js